export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6218.32921d5f.jpg";